import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

/** A21 — Documents (GED proxy) */
const DocumentsPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.comptabilite.pages.documentsPage.${key}`, opts);

  return (
    <>
      <span className="sr-only">{p('redirect_message')}</span>
      <Navigate to="/documents/accounting-tax" replace />
    </>
  );
};

export default DocumentsPage;
